import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import SpinningSpark from '../shared/components/SpinningSpark';
import { useUser } from '../auth/User.context';
import config from '../config';

export default function Home() {
  const { MENU_ITEMS } = config;
  const {
    state: {
      adminPanelActivePermissions,
      authenticated,
      userIsLoading,
      userPermissions,
    },
  } = useUser();

  const permissionsToRouteMap = {
    'Manage Users': '/users',
    'Manage Stores': '/stores',
    'Manage Priorities': '/priorities',
    'Manage Post of the Day': '/potd',
    'Manage Decision': '/videoReviewDashboard',
    'View Video Report': '/powerbi',
    'Manage Stickers': '/stickers',
    'Manage Store Photos': '/StorePhotosReview',
    'Manage Templates': '/templates',
    'Manage Content Requests': '/tasks',
    'Manage Alerts': '/alerts',
    'View Field Guide': '/guide',
  };

  const navigate = useNavigate();

  // Function to check if a permission title is related to PowerBI
  const isPowerBIPermission = (permissionTitle) =>
    permissionTitle.startsWith('View PowerBI:');

  useEffect(() => {
    const mappedAdminPanelActivePermissions = adminPanelActivePermissions.map(
      (permission) => permission.title
    );
    const mappedUserPermissions = userPermissions.map(
      (permission) => permission.title
    );

    if (!userIsLoading && authenticated) {
      // Check for PowerBI permissions first
      const powerBIPermission = mappedUserPermissions.find((permission) =>
        isPowerBIPermission(permission)
      );

      if (powerBIPermission && MENU_ITEMS.includes('PowerBI')) {
        // Redirect to PowerBI page if user has 'View PowerBI:' permissions
        navigate('/powerbi');
      } else {
        // If no PowerBI permissions, check for other mapped permissions
        const match = mappedUserPermissions.find((permission) =>
          mappedAdminPanelActivePermissions.includes(permission)
        );

        const route = match && permissionsToRouteMap[match];
        if (route) {
          navigate(route);
        } else {
          // No mapped page for this permission, or no matching permission
          navigate('/unauthorized');
        }
      }
    }
  }, [
    authenticated,
    userIsLoading,
    userPermissions,
    adminPanelActivePermissions,
    navigate,
  ]);

  return (
    <Grid
      container
      direction="column"
      style={{
        minHeight: '100vh',
        marginTop: 20,
        alignItems: 'center',
        justify: 'center',
      }}
    >
      <SpinningSpark />
    </Grid>
  );
}
